module.exports = __webpack_public_path__ + "img/arrow-down.7126f68d.png";